import axios from "axios";
import styles from "./FaqAdd.module.css";
import { API } from "../../config";
import { useState } from "react";
import Spinner from "../Spinner/Spinner";
import Popup from "../Popup/Popup";
import { useNavigate } from "react-router-dom";

export const FaqAdd = () => {
  const navigate = useNavigate();
  const [spin, setSpin] = useState(false);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [faq, setFaq] = useState({
    question: "",
    answer: "",
  });

  const change = () => {
    setShow(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFaq({ ...faq, [name]: value });
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!faq.question.trim()) {
      newErrors.question = "Question is required";
    } else if (faq.question.trim().length < 5) {
      newErrors.question = "Question must be at least 5 characters";
    }

    if (!faq.answer.trim()) {
      newErrors.answer = "Answer is required";
    } else if (faq.answer.trim().length < 10) {
      newErrors.answer = "Answer must be at least 10 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    window.scrollTo(0, 0);
    setSpin(true);

    try {
      const response = await axios.post(`${API}/Admin/faqs`, faq);
      console.log(response);
      setShow(true);
      setSpin(false);
      setFaq({ question: "", answer: "" });
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.log(error);
      setErrors({
        submit:
          error.response?.data?.message ||
          "Failed to create FAQ. Please try again.",
      });
      setSpin(false);
    }
  };

  return (
    <>
      {spin ? <Spinner /> : null}
      {show ? (
        <Popup show={show} switch={change} message="FAQ Added Successfully" />
      ) : null}
      <div className={styles.clientpage}>
        <div className={styles.heading}>
          <h1 className={styles.details}>Add New FAQ</h1>
          <form onSubmit={handleSubmit}>
            <div className={styles.items}>
              <div className={styles.second}>
                <p>Enter the Question</p>
                <input
                  name="question"
                  placeholder="Enter the question"
                  type="text"
                  value={faq.question}
                  onChange={handleChange}
                  id={styles.gap}
                  required
                />
                {errors.question && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    {errors.question}
                  </div>
                )}
              </div>

              <div className={styles.second}>
                <p>Enter the Answer</p>
                <textarea
                  name="answer"
                  placeholder="Enter the answer"
                  value={faq.answer}
                  onChange={handleChange}
                  id={styles.textarea}
                  required
                  rows={6}
                />
                {errors.answer && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    {errors.answer}
                  </div>
                )}
              </div>

              {errors.submit && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    marginTop: "8px",
                    marginBottom: "8px",
                  }}
                >
                  {errors.submit}
                </div>
              )}

              <div className={styles.button}>
                <input type="submit" className={styles.bttn} value="Submit" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
